import type { Me } from '../../lib/api.ts';
import { logout } from '../../lib/api.ts';

export interface LoginButtonProps {
  readonly me: Me | null;
  readonly onSignedOut: () => void;
}

/**
 * The signed-in account chip.
 *
 * Renders nothing when signed out: sign-in is the email form, which owns its
 * own disclosure. A second signed-out control here would compete with "Play
 * now" and imply an account is required, which it is not.
 */
export function LoginButton({ me, onSignedOut }: LoginButtonProps) {
  if (!me) return null;

  return (
    <div className="account">
      <span className="account__name">{me.displayName}</span>
      <button
        type="button"
        className="button button--quiet"
        onClick={() => {
          void logout().then(onSignedOut);
        }}
      >
        Sign out
      </button>
    </div>
  );
}
